var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.607178,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#31343F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7932 29.6072V26.6072H16.6132V24.3872C17.1332 23.5605 17.6199 22.6872 18.0732 21.7672C18.5265 20.8472 18.9465 19.8738 19.3332 18.8472C19.7332 17.8205 20.0665 16.7538 20.3332 15.6472H23.1932C23.0465 16.2872 22.8399 16.9605 22.5732 17.6672C22.3199 18.3738 22.0265 19.0738 21.6932 19.7672C21.3599 20.4605 21.0199 21.1138 20.6732 21.7272C20.3399 22.3272 20.0199 22.8605 19.7132 23.3272C19.4065 23.7938 19.1465 24.1472 18.9332 24.3872H22.7932V21.0672C22.9265 20.8138 23.0599 20.5405 23.1932 20.2472C23.3399 19.9405 23.4799 19.6338 23.6132 19.3272C23.7465 19.0072 23.8665 18.6938 23.9732 18.3872C24.0932 18.0805 24.1865 17.7938 24.2532 17.5272H25.5332V24.3872H27.2932V26.6072H25.5332V29.6072H22.7932Z",
    fill: "#FCFCF9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e5aedfeca14c98cd07b63cfd503519a6.svg";
export { ForwardRef as ReactComponent };